export const HOURS_PER_DAY = 7;
export const HALF_DAY_HOURS = HOURS_PER_DAY / 2;
// 3,5h
export const WORKING_DAYS_PER_MONTH = 20;
export const MONTHS_FULL = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];
export const TODAY = new Date();
TODAY.setHours(0, 0, 0, 0);
